import React from "react";
import './index.css'
import { useEffect } from "react";
import Header from './components/header/Header'
import Skills from "./components/skills/Skills";
import Nav from "./components/nav/Nav";
import Experience from "./components/experience/Experience";
import Portfolio from "./components/portfolio/Portfolio";
import About from "./components/about/About"
import Contact from "./components/contact/Contact"
import Footer from "./components/footer/Footer";



const App = () => {

    // Fade elements in the first time they scroll into view.
    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('is-visible');
                    observer.unobserve(entry.target);
                }
            });
        }, { threshold: 0.1 });

        document.querySelectorAll('.reveal').forEach((el) => observer.observe(el));
        return () => observer.disconnect();
    }, [])

    return(
        <>
            <Nav />
            <main>
                <Header />
                <About />
                <Experience />
                <Portfolio />
                <Skills />
                <Contact />
            </main>
            <Footer />
        </>
    )
}

export default App
